import { render, staticRenderFns } from "./TableStickyRow.vue?vue&type=template&id=a31cb134"
import script from "./TableStickyRow.vue?vue&type=script&lang=js"
export * from "./TableStickyRow.vue?vue&type=script&lang=js"
import style0 from "./TableStickyRow.vue?vue&type=style&index=0&id=a31cb134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports